// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GwYe","badges":"styles_badges__1f1Ca"};